import React from 'react'
import css from './Pill.module.css'
import cx from 'classnames'

const Pill = ({ children, type, className, ...props }) => (
  <span className={cx({
    [css.wrapper]: true,
    [className]: !!className,
    [css[type]]: true
  })} {...props}>
    {children}
  </span>
)

Pill.defaultProps = {
  type: 'primary'
}

Pill.displayName = 'Pill'

export default Pill



// WEBPACK FOOTER //
// ./components/Customers/presentational/Pill.js